import { ModelSagres } from "@/types/model-sagres";

export interface AvaliacaoGeralJson {
  id: number;
  dhAvaliacao: string;
  tipo: string;
  metricaAno: number;
  metricaDs: string;
  qtdTotal: number;
  qtdFinalizada: number;
  qtdErro: number;
  publico: boolean;
}
   

export class AvaliacaoGeral extends ModelSagres {
  id: number;
  dhAvaliacao: Date;
  tipo: string;
  metricaAno: number;
  metricaDs: string;
  qtdTotal: number;
  qtdFinalizada: number;
  qtdErro: number;
  publico: boolean;  

  /**
   * @param obj
   */
  constructor(obj?: AvaliacaoGeralJson) {
    super();
    if (obj) {
      this.id = obj.id;
      this.dhAvaliacao = new Date(obj.dhAvaliacao);
      this.tipo = obj.tipo;
      this.metricaAno = obj.metricaAno;
      this.metricaDs = obj.metricaDs;
      this.qtdTotal = obj.qtdTotal;
      this.qtdFinalizada = obj.qtdFinalizada;
      this.qtdErro = obj.qtdErro;
      this.publico = obj.publico;
    }
  }
}